var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5735 0.183594C14.2721 0.183594 11.0448 1.16259 8.29971 2.99677C5.55466 4.83096 3.41515 7.43795 2.15174 10.4881C0.888336 13.5382 0.557771 16.8945 1.20185 20.1325C1.84593 23.3705 3.43573 26.3448 5.7702 28.6793C8.10468 31.0138 11.079 32.6036 14.317 33.2477C17.555 33.8917 20.9113 33.5612 23.9614 32.2978C27.0116 31.0344 29.6186 28.8948 31.4527 26.1498C33.2869 23.4047 34.2659 20.1774 34.2659 16.876C34.2659 12.4489 32.5073 8.20312 29.3768 5.07268C26.2464 1.94225 22.0006 0.183594 17.5735 0.183594V0.183594ZM27.0604 12.849L16.5859 24.7284C16.4168 24.9188 16.2119 25.074 15.9827 25.185C15.7535 25.296 15.5047 25.3606 15.2505 25.3752H15.1253C14.6509 25.3781 14.1923 25.2046 13.8386 24.8883L8.23272 19.9154C7.8472 19.5732 7.61339 19.0919 7.58274 18.5773C7.55209 18.0628 7.7271 17.5571 8.06928 17.1716C8.41145 16.7861 8.89277 16.5523 9.40733 16.5216C9.9219 16.491 10.4276 16.666 10.8131 17.0081L14.9862 20.6874L24.174 10.2547C24.5152 9.86823 24.996 9.63317 25.5106 9.60121C26.0251 9.56926 26.5313 9.74302 26.9178 10.0843C27.3042 10.4255 27.5393 10.9063 27.5712 11.4209C27.6032 11.9355 27.4294 12.4416 27.0882 12.8281L27.0604 12.849Z",
    fill: "#B97E12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3848,
    height: 33.3848,
    fill: "white",
    transform: "translate(0.880859 0.183594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.26d3da2f661a11f2a14ad30bc07c3685.svg";
export { ForwardRef as ReactComponent };